// Centralized API configuration for all environments
export const getApiBaseUrl = () => {
	const hostname = window.location.hostname;

	if (hostname === "parts-planning.productionanalytics-dev.rio.cloud") {
		return "https://l5nnxmztlf.execute-api.eu-west-1.amazonaws.com/dev";
	} else if (
		hostname === "parts-planning-development.productionanalytics-dev.rio.cloud"
	) {
		return "https://803ibgyhs2.execute-api.eu-west-1.amazonaws.com/dev";
	} else if (hostname === "dkjse7swa4vah.cloudfront.net") {
		return "https://l5nnxmztlf.execute-api.eu-west-1.amazonaws.com/dev";
	} else {
		// Local development
		return "http://localhost:8000";
	}
};

// Get API base URL with /api prefix for cache service
export const getApiBaseUrlWithPrefix = () => {
	return `${getApiBaseUrl()}/api`;
};

// Environment detection utilities
export const getEnvironment = () => {
	const hostname = window.location.hostname;

	if (
		hostname === "parts-planning.productionanalytics-dev.rio.cloud" ||
		hostname === "parts-planning-development.productionanalytics-dev.rio.cloud" ||
		hostname === "duyeg4fc0hbv9.cloudfront.net"
	) {
		return "dev";
	} else {
		return "local";
	}
};

// The "development" branch host (and local dev) uses a green active-tab accent
// plus a "DEV" chip to visually distinguish it from production, which keeps the
// red accent and shows no chip. Matches the development host + localhost only.
export const isDevBranchEnvironment = () => {
	const hostname = window.location.hostname;
	return (
		hostname === "parts-planning-development.productionanalytics-dev.rio.cloud" ||
		hostname === "localhost" ||
		hostname === "127.0.0.1"
	);
};

export const isDevelopment = () => {
	return getEnvironment() === "local";
};

export const isProduction = () => {
	return getEnvironment() === "production";
};

// Get the frontend base URL for email links and direct navigation
export const getFrontendBaseUrl = () => {
	const hostname = window.location.hostname;

	if (hostname === "parts-planning.productionanalytics-dev.rio.cloud") {
		return "https://parts-planning.productionanalytics-dev.rio.cloud";
	} else if (
		hostname === "parts-planning-development.productionanalytics-dev.rio.cloud"
	) {
		return "https://parts-planning-development.productionanalytics-dev.rio.cloud";
	} else {
		// Local development - use current origin
		return window.location.origin;
	}
};

//© yasshsakhare
